import Marquee from "react-fast-marquee";
import { Diamond } from "lucide-react";

const ITEMS = [
  "Análise de Dados Algorítmica",
  "Monitoramento 24/7",
  "Precisão Máxima",
  "Sinais em Tempo Real",
  "Plataformas Oficiais",
  "Conteúdo Informativo",
];

export const EditorialMarquee = () => (
  <div
    className="relative border-y border-white/[0.08] bg-[#0c0c0c]/60 py-5"
    data-testid="editorial-marquee"
  >
    <Marquee speed={38} gradient gradientColor="#120D0D" gradientWidth={120}>
      {ITEMS.concat(ITEMS).map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-sm md:text-base tracking-[0.25em] uppercase text-white/40 px-8">
            {item}
          </span>
          <Diamond className="w-3 h-3 text-[#F5C542]" strokeWidth={2.5} />
        </div>
      ))}
    </Marquee>
  </div>
);
